export default __webpack_public_path__ + "media/images/logo_wordmark-68d719efc2be9d0a86ba316357599f95.png";